import { jump } from '@utils/navigate';
import { notification } from '@ss/mtd-react';

// 简单的上传文件组件，因为后端不支持useFormdata参数，mtd中的helper默认的都是使用formdata
const uploadHelper = (url: string, file, options: { headers: any; onSuccess: any; onError?: any }) => {
  const { headers, onSuccess, onError } = options;
  window
    .fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/octet-stream',
        ...headers,
      },
      body: file,
    })
    .then((_res) => {
      if (_res && _res.status === 504) {
        onError('上传文件超时，建议重试');
        return;
      }
      _res
        .json()
        .then((res) => {
          if (res.status === 1) {
            onSuccess?.(res.data);
          } else if (res.status === 401) {
            notification.error({
              message: '登录失效，请重新登录',
            });
            const targetUrl = `${window.location.origin}/m/login?redirectUrl=${encodeURIComponent(
              window.location.href,
            )}`;
            jump(targetUrl, { isAppendQuery: false });
          } else {
            onError?.(res.message);
          }
        })
        .catch((err) => {
          console.error(err);
          onError();
        });
    })
    .catch(() => {
      onError();
    });
};
export default uploadHelper;
